// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Copy = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Copy = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Copy = _exports.Copy = function Copy(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.0781 12.5391H8.98438C8.70508 12.5391 8.47656 12.3105 8.47656 12.0312V3.90625C8.47656 3.62695 8.70508 3.39844 8.98438 3.39844H13.4309L15.5859 5.55347V12.0312C15.5859 12.3105 15.3574 12.5391 15.0781 12.5391ZM8.98438 14.0625H15.0781C16.1985 14.0625 17.1094 13.1516 17.1094 12.0312V5.55347C17.1094 5.15039 16.9475 4.76318 16.6619 4.47754L14.51 2.32251C14.2244 2.03687 13.8372 1.875 13.4341 1.875H8.98438C7.86401 1.875 6.95312 2.78589 6.95312 3.90625V12.0312C6.95312 13.1516 7.86401 14.0625 8.98438 14.0625ZM4.92188 5.9375C3.80151 5.9375 2.89062 6.84839 2.89062 7.96875V16.0938C2.89062 17.2141 3.80151 18.125 4.92188 18.125H11.0156C12.136 18.125 13.0469 17.2141 13.0469 16.0938V15.0781H11.5234V16.0938C11.5234 16.373 11.2949 16.6016 11.0156 16.6016H4.92188C4.64258 16.6016 4.41406 16.373 4.41406 16.0938V7.96875C4.41406 7.68945 4.64258 7.46094 4.92188 7.46094H5.9375V5.9375H4.92188Z",
      fill: "#212B36"
    }));
  };
});
